import Icon from './Icon';
import { trustPoints } from '../constants/content';

export default function TrustBar() {
  return (
    <section className="trustbar">
      <div className="container">
        <div className="trustbar__grid">
          {trustPoints.map((point) => (
            <article key={point.title} className="trust-item">
              <span className="trust-item__icon">
                <Icon name={point.icon} size={22} />
              </span>
              <div>
                <h3>{point.title}</h3>
                <p>{point.text}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
